'use client'
import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import tailwindConfig from '@tailwind.config'
import LinkComponent from '@components/LinkComponent'
import { IoMdVideocam } from 'react-icons/io'

function GallerySlider({ images, alt, blur }) {
    const [index, setIndex] = useState(0)
    const [hovered, setHovered] = useState(false)
    const touchStart = useRef(null)
    const total = images?.length ?? 0
    if (!total) return null
    const prev = (e) => { e.preventDefault(); e.stopPropagation(); setIndex(i => (i - 1 + total) % total) }
    const next = (e) => { e.preventDefault(); e.stopPropagation(); setIndex(i => (i + 1) % total) }
    const onTouchStart = (e) => { touchStart.current = e.touches[0].clientX }
    const onTouchEnd = (e) => {
        if (touchStart.current === null) return
        const delta = touchStart.current - e.changedTouches[0].clientX
        if (Math.abs(delta) > 40) delta > 0 ? setIndex(i => (i + 1) % total) : setIndex(i => (i - 1 + total) % total)
        touchStart.current = null
    }
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            {images.map((src, i) => (
                <div key={i} style={{ position: 'absolute', inset: 0, opacity: i === index ? 1 : 0, transition: 'opacity 0.3s ease', pointerEvents: i === index ? 'auto' : 'none' }}>
                    <Image placeholder={i === 0 && blur ? 'blur' : 'empty'} blurDataURL={i === 0 ? blur : undefined} src={src || '/images/imageplaceholder.jpeg'} fill alt={`${alt} ${i + 1}`} style={{ objectFit: 'cover' }} />
                </div>
            ))}
            {total > 1 && (
                <>
                    <button onClick={prev} style={{ position: 'absolute', insetInlineStart: 8, top: '50%', transform: 'translateY(-50%)', zIndex: 4, background: 'rgba(0,0,0,0.35)', border: 'none', borderRadius: 6, width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#fff', backdropFilter: 'blur(4px)', padding: 0, opacity: 1, transition: 'opacity 0.2s ease' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
                    </button>
                    <button onClick={next} style={{ position: 'absolute', insetInlineEnd: 8, top: '50%', transform: 'translateY(-50%)', zIndex: 4, background: 'rgba(0,0,0,0.35)', border: 'none', borderRadius: 6, width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#fff', backdropFilter: 'blur(4px)', padding: 0, opacity: 1, transition: 'opacity 0.2s ease' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                    </button>
                    <div style={{ position: 'absolute', bottom: 8, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 5, zIndex: 4, opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
                        {images.map((_, i) => <button key={i} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIndex(i) }} style={{ width: i === index ? 16 : 6, height: 6, borderRadius: 3, border: 'none', padding: 0, cursor: 'pointer', background: i === index ? '#fff' : 'rgba(255,255,255,0.5)', transition: 'all 0.2s ease' }} />)}
                    </div>
                    <div style={{ position: 'absolute', top: 8, insetInlineStart: 8, zIndex: 4, background: 'rgba(0,0,0,0.4)', color: '#fff', fontSize: '0.65rem', fontWeight: 600, padding: '2px 7px', borderRadius: 20, backdropFilter: 'blur(4px)', letterSpacing: '0.04em', opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
                        {index + 1} / {total}
                    </div>
                </>
            )}
        </div>
    )
}

const LargeNewDevelopmentCard = ({ project, imageWidth = 300, imageHeight = 200, includeInactive = false, newLimit, isLast, district = undefined, dictionary, lang }) => {

    const cardRef = useRef();

    // const handleLike = async () => {
    //     const isLike = await sendLike(project.id)
    //     setIsLiked((prevLike) => !prevLike)
    //     project.isLiked = !project.isLiked
    // };

    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    // useEffect(() => {
    //     if (session !== null) {
    //         setShowLikeBtn(true)
    //     }
    // }, [])

    let location = 'Pattaya'

    switch (lang) {
        case 'en':
            location = 'Pattaya'
            break;
        case 'th':
            location = 'พัทยา'
            break;
        case 'cn':
            location = '芭提雅'
            break;
        default:
            break;
    }

    // const isSmallDevice = window.innerWidth < 768;
    // const isTablet = window.innerWidth < 1024;

    const galleryImages = (project.gallery && project.gallery.length > 0)
        ? project.gallery
        : [project.cover]

    return (
        <div className={`sm:w-[${imageWidth}px] w-full rounded-lg shadow-md hover:shadow-sm hover:shadow-maincolor`}
            ref={cardRef}
        
        >
            <LinkComponent
                className='w-full'
                href={'/new-developments/' + project.slug}
            >
                <div className='sm:w-[300px] w-full'>
                    <div className='relative'>
                        <div className='relative sm:w-[300px] w-full aspect-[4/3] rounded-t-md overflow-hidden'>
                            <GallerySlider
                                images={galleryImages}
                                alt={project.slug}
                                blur={project.blur}
                            />
                        </div>
                        {(project.videoUrl) ? (
                            <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap z-10 pointer-events-none'>
                                {project.videoUrl ? (
                                    <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                ) : null}
                            </div>
                        ) : null}
                        {(project.promotionTitle) ? (
                            <div className='absolute w-full top-1 left-1 flex flex-row flex-wrap z-10 pointer-events-none'>
                                <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><span className='ml-1'>{project.promotionTitle}</span></div>
                            </div>
                        ) : null}
                        {/* {project.isPromotion ? (
                            <div className='absolute top-2 bg-third text-light p-1 rounded-r-md z-10 font-semibold'>{project.promotionTitle}</div>
                        ) : null
                        } */}
                    </div>
                    <div className='p-2'>
                    <div className='text-maincolor text-xl font-semibold rounded-r-md z-10 w-full sm:h-[60px] overflow-hidden'><h3 className='line-clamp-2'>{project.name}</h3></div>
                    <div className='flex flex-row w-full'>
                        {project.fromPrice && (
                            <div className='text-xl font-semibold text-third w-1/2'>{project.fromPrice}</div>
                            )}
                    </div>
                    <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                        <p className='text-secondary text-xl'>{project.districts[0]?.subdistrictName?.[lang] ? project.districts[0]?.subdistrictName?.[lang] : project.districts[0]?.subdistrict}, {location}</p>
                    </div>
                    <div className=' h-[28px]'>
                        {project.startingPrice && (
                            <span className='text-xl text-maincolor'>{dictionary.fromPriceFront}{project.startingPrice}{dictionary.fromPriceAfter}</span>
                        )}
                    </div>
                    {/* <div className='flex flex-row w-full justify-between'>
                        <div className='flex flex-row items-center w-full'>
                            <BiArea
                                color={tailwindConfig.theme.extend.colors.secondary}
                            />
                            <span className='ml-2 text-xl text-maincolor'>{project.layouts.length} {dictionary.availableLayouts}</span>
                        </div>
                    </div> */}
                    </div>
                </div>
            </LinkComponent >
        </div>
    )
}

export default LargeNewDevelopmentCard